"use client"

import { useMountAdcell } from "src/integrations/adcell/state"
import { IntegrationScript } from "../lib/IntegrationScript"
import { adcellPid } from "./constants"

const src = `https://t.adcell.com/js/inlineretarget.js?method=track
&pid=${adcellPid}&type=startpage`

export const AdcellHomeTag = () => {
  const mountAdcell = useMountAdcell()

  if (!mountAdcell) {
    return null
  }

  return <IntegrationScript id="adcell_home" src={src} />
}
